import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"height":"100%"} }
const _hoisted_2 = ["id", "src", "title", "height", "width"]
const _hoisted_3 = {
  style: {"height":"100%"},
  class: "d-flex justify-center"
}
const _hoisted_4 = ["id", "src", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      id: _ctx.iframeId,
      src: _ctx.url,
      title: _ctx.name,
      frameBorder: "0",
      height: _ctx.height,
      width: _ctx.width
    }, null, 8, _hoisted_2),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.dialogStatusSync,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogStatusSync) = $event)),
      title: _ctx.name,
      "max-width": "60vw"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("iframe", {
            id: _ctx.iframeId,
            src: _ctx.url,
            title: _ctx.name,
            frameBorder: "0",
            height: "600",
            width: "600"
          }, null, 8, _hoisted_4)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}